import type { SxProps, Theme } from '@mui/material'

/** Shared styling for the pill buttons in the sidebar's bottom section (Resources / FAQs / Settings). */
export const SIDEBAR_PILL_SX: SxProps<Theme> = {
	padding: '4px 15px',
	border: 'none',
	backgroundColor: '#e8e8ff',
	borderRadius: '8px',
	fontWeight: '600',
	color: '#6376f5 !important',
	fontSize: '12px'
}

export const CHECKOUT_FAQ_URL = 'https://scratchcheckout.stonly.com/kb/en/'
export const LENDING_FAQ_URL = 'https://scratchpay-lending.stonly.com/kb/en'
export const CHECK_ONLY_FAQ_URL =
	'https://scratchcheckout.stonly.com/kb/en/check-ach-payments-363020'

/** Private, SEO-disabled KB the PIMS guides moved to — reachable by direct link only (DASH-9523). */
export const PIMS_USER_GUIDES_URL = 'https://scratch-user-guides.stonly.com/kb/en/'
export const FEATURE_UPDATES_URL = 'https://scratchpay.com/practices/feature-updates'
